import createTaskAction from '@esentai/core/ducks/tasks/createTaskAction';

import { UPDATE_FEED_LAYOUT } from './types';

export const updateFeedLayout = createTaskAction(UPDATE_FEED_LAYOUT);
